@if (form) {
  <div [formGroup]="form">
    <div class="cord-label">
      <h3 class="label">{{ (form.controls.source.value === RosterUploadFileType.External ? 'SELECTED_STUDENTS' : 'SELECT_STUDENTS') | translate }}</h3>
    </div>
    <!-- Upload type switcher -->
    @if (form.controls.source.value !== RosterUploadFileType.External) {
      <div *appHasAnyAuthority="authority.Admin" class="form-group d-flex">
        <div class="custom-control custom-radio mr-4">
          <input
            type="radio"
            id="manualUpload"
            name="students"
            class="custom-control-input"
            [checked]="form.controls.source.value === uploadFileTypes.Manual"
            (change)="onUploadTypeChange(uploadFileTypes.Manual)"
            />
          <label class="custom-control-label custom-control-label-sm" for="manualUpload">{{
            'MANUAL_UPLOAD' | translate
          }}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="serverUpload"
            name="students"
            class="custom-control-input"
            [checked]="form.controls.source.value === uploadFileTypes.Automatic"
            (change)="onUploadTypeChange(uploadFileTypes.Automatic)"
            />
          <label class="custom-control-label custom-control-label-sm" for="serverUpload">{{
            'SERVER_UPLOAD' | translate
          }}</label>
        </div>
        <app-form-error [control]="form.controls.source" errorElementId="roster-students-upload-err-source"></app-form-error>
      </div>
    }
    <!-- Automatic upload -->
    <div *appHasAnyAuthority="authority.Admin" [hidden]="form.controls.source.value !== uploadFileTypes.Automatic">
      <div class="form-group" appParentValidator [control]="form.controls.file">
        <div class="app-input">
          <!-- WCAG 1.3.1 — label for/id on combobox; 3.3.1 — error id -->
          <label for="automaticUpload" id="automaticUpload-a11y-label">{{ 'FILE_NAME' | translate }}</label>
          <app-auto-complete
            inputId="automaticUpload"
            labelElementId="automaticUpload-a11y-label"
            [ariaLabel]="'FILE_NAME' | translate"
            [describedBy]="hasVisibleError('file') ? 'roster-students-upload-err-file' : null"
            (selectedItemChange)="onSelectChange($event)"
            (searchChange)="onSearchChange($event)"
            [selectedItem]="form.controls.file.value"
            [minTermLength]="1"
            [itemsData]="files"
          ></app-auto-complete>
        </div>
        <app-form-error [control]="form.controls.file" errorElementId="roster-students-upload-err-file"></app-form-error>
      </div>
      <!-- List of selected items -->
      @if (form.controls.items.value && form.controls.items.value.length > 0) {
        <ul class="list-group list-group-remove">
          @for (item of getSortedItems(form.controls.items.value); track item) {
            <li class="list-group-item">
              <b class="mr-3">{{ item?.extraLabels?.firstLabel }} {{ item?.extraLabels?.secondLabel }}</b>
              {{ item?.extraLabels?.thirdLabel }}
              <span class="ml-auto">
                <!-- WCAG 4.1.2 -->
                <button
                  type="button"
                  class="round-btn round-btn-xs list-group-action ml-1"
                  (click)="onRemove(item)"
                  [appTooltip]="'REMOVE' | translate"
                  [attr.aria-label]="'REMOVE' | translate"
                  >
                  <i class="ftmi-cross" aria-hidden="true"></i>
                </button>
              </span>
            </li>
          }
        </ul>
      }
      @if (!form.controls.items.value || form.controls.items.value.length === 0) {
        <div
          class="empty-list-message small"
          role="status"
          aria-live="polite"
          >
          {{ 'ROSTER_LIST_EMPTY_MESSAGE' | translate }}
        </div>
      }
    </div>
    <!-- Manual upload -->
    <div [hidden]="form.controls.source.value !== uploadFileTypes.Manual">
      <app-roster-manual-upload [form]="form"> </app-roster-manual-upload>
    </div>
    @if (form.controls.source.value === RosterUploadFileType.External) {
      <div>
        @if (form.controls.items.value && form.controls.items.value.length > 0) {
          <ul class="list-group list-group-remove">
            @for (item of form.controls.items.value; track item) {
              <li class="list-group-item">
                <b class="mr-3">{{ item?.extraLabels?.firstLabel }} {{ item?.extraLabels?.secondLabel }}</b>
                {{ item?.extraLabels?.thirdLabel }}
                @if (form.controls.source.value !== RosterUploadFileType.External) {
                  <span class="ml-auto">
                    <!-- WCAG 4.1.2 -->
                    <button
                      type="button"
                      class="round-btn round-btn-xs list-group-action ml-1"
                      (click)="onRemove(item)"
                      [appTooltip]="'REMOVE' | translate"
                      [attr.aria-label]="'REMOVE' | translate"
                      >
                      <i class="ftmi-cross" aria-hidden="true"></i>
                    </button>
                  </span>
                }
              </li>
            }
          </ul>
        }
        @if (form.controls.items.value === null || form.controls.items.value.length === 0) {
          <div
            class="empty-list-message small"
            role="status"
            aria-live="polite"
            >
            {{ 'ROSTER_EXTERNAL_EMPTY_MESSAGE' | translate }}
          </div>
        }
      </div>
    }
  </div>
}
